import generateControlTreatment from "./generateControlTreatment";
import initiateSplitClient from "./initiateSplitClient";
import isClientSide from "./isClientSide";
/**
 * Function for getting treatments in server-side code
 *
 * @param treatmentNames - The treatment(s) you want to retrieve from Split
 * @param splitKey - The Split key (or Promise of Split key) to be used
 * @param options.attributes - Additional attributes to send to Split.
 **/
const getServerSideSplitTreatments = async (treatmentNames, splitKey, { attributes } = {}) => {
    try {
        if (isClientSide()) {
            throw new Error("getServerSideSplitTreatments can't be used client-side, use getClientSideSplitTreatments instead");
        }
        // We sometimes use conditional logic to determine whether or not to
        // send a treatment name to this function. To avoid excess logic on
        // the frontend, we'll just return an empty object if no treatments end
        // up being passed in.
        if (!treatmentNames || !treatmentNames.length) {
            return {};
        }
        const client = await initiateSplitClient();
        const treatments = client.getTreatmentsWithConfig(await splitKey, [].concat(treatmentNames), attributes);
        if (Object.keys(treatments).length) {
            const formattedTreatments = {};
            Object.keys(treatments).forEach((treatmentName) => {
                const { treatment, config } = treatments[treatmentName];
                if (!config) {
                    formattedTreatments[treatmentName] = {
                        treatment,
                    };
                }
                else {
                    formattedTreatments[treatmentName] = {
                        config: JSON.parse(String(config)),
                        treatment,
                    };
                }
                if (treatment === "control" && process.env.LEAFLY_ENV === "prod") {
                    console.error(new Error(`getServerSideSplitTreatment succeeded but returned control treatment returned for flag ${treatmentName}`));
                }
            });
            return formattedTreatments;
        }
        else {
            throw new Error(`getServerSideSplitTreatments succeeded but returned no treatments for flag ${String(treatmentNames)}`);
        }
    }
    catch (e) {
        console.error(new Error((typeof e === "object" && e.message) ||
            `getServerSideSplitTreatments caught for test ${String(treatmentNames)}`));
        return generateControlTreatment(treatmentNames);
    }
};
export default getServerSideSplitTreatments;
